// import React, { useState } from 'react';
// import './Signup.css';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// function SignupForm() {
//   const [company, setCompany] = useState('');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [phone, setPhone] = useState('');
//   const [industry, setIndustry] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');

//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const payload = { company, email, password, phone, industry };
//       console.log('Payload:', payload); // Debug: Log payload

//       const response = await fetch('/api/signup-hire', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();
//       console.log('Response:', data); // Debug: Log server response

//       if (!response.ok) {
//         throw new Error(data.error || 'Signup failed.');
//       }

//       localStorage.setItem('user_email', data.email); // Store token in sessionStorage
//       navigate(`/companyhome`);
//     } catch (error) {
//       console.error('Error in signup request:', error);
//       setErrorMessage(error.message || 'Signup failed.');
//     }
//   };




//   return (
//     <div className="joinus-signup">
//       <div className="section-container">
//         <img
//           loading="lazy"
//           src="./same.jpg" alt="Join us illustration"
//           className="login-image"
//         />
//         <div className="joinus-content">
//           <div className="content1">
//             <h1 className="joinus-title">Join us today 👋</h1>
//             <p className="joinus-subtitle">
//               Together, We Create Opportunities for Growth, Collaboration, and
//               Innovation – Join Us to Be a Part of Something Bigger.
//             </p>
//           </div>
//           <div className="content2">
//             <form onSubmit={handleSubmit}>
//               <div className="joinus-input-group">
//                 <label htmlFor="company" className="joinus-input-label">Company Name</label>
//                 <input
//                   type="text"
//                   id="company"
//                   className="joinus-input-field"
//                   placeholder="i.e. Innova"
//                   value={company}
//                   onChange={(e) => setCompany(e.target.value)}
//                 />
//               </div>
//               <div className="joinus-input-group">
//                 <label htmlFor="email" className="joinus-input-label">Email Address</label>
//                 <input
//                   type="email"
//                   id="email"
//                   className="joinus-input-field"
//                   placeholder="i.e. example@innova.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>

//               <div className="joinus-input-group">
//                 <label htmlFor="password" className="joinus-input-label">Password</label>
//                 <input
//                   type="password"
//                   id="passwordd"
//                   className="joinus-input-field"
//                   placeholder="**********"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                 />
//               </div>

//               <div className="joinus-input-group">
//                 <label htmlFor="phone" className="joinus-input-label">Phone</label>
//                 <input
//                   type="phone"
//                   id="phone"
//                   className="joinus-input-field"
//                   placeholder="Phone Number"
//                   value={phone}
//                   onChange={(e) => setPhone(e.target.value)}
//                 />
//               </div>

//               <div className="joinus-input-group">
//                 <label htmlFor="industry" className="joinus-input-label">Industry</label>
//                 <input
//                   type="industry"
//                   id="industry"
//                   className="joinus-input-field"
//                   placeholder="Industry"
//                   value={industry}
//                   onChange={(e) => setIndustry(e.target.value)}
//                 />
//               </div>

//               <div className="joinus-remember-me">
//                 <input
//                   type="checkbox"
//                   id="remember"
//                   className="joinus-checkbox"
//                 />
//                 <label htmlFor="remember">Remember me</label>
//               </div>

//               <button className="joinus-create-account-btn" type="submit">
//                 Create Account
//               </button>
//               {errorMessage && <p className="error-message">{errorMessage}</p>}

//               <p className="joinus-login-link">
//                 Already have an account? <a href="/login">Log in</a>
//               </p>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default SignupForm;

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import OtpModal from '../../OtpBox/OtpModal';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Text, Heading } from '@/components/ui/typography';
import { Building2, Mail, Lock, Phone, Briefcase } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getColor } from '@/config/theme';
import {
  normalizeEmail,
  isValidEmail,
  validatePassword,
  validatePhone,
} from '@/utils/formValidation';


function SignupForm() {
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [industry, setIndustry] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [otpVisible, setOtpVisible] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const navigate = useNavigate();

  const validateForm = () => {
    const normalizedEmail = normalizeEmail(email);

    if (!company.trim()) {
      return 'Company name is required.';
    }
    if (company.trim().length < 2) {
      return 'Company name must be at least 2 characters.';
    }
    if (!normalizedEmail) {
      return 'Email is required.';
    }
    if (!isValidEmail(normalizedEmail)) {
      return 'Please enter a valid email address.';
    }

    const passwordError = validatePassword(password);
    if (passwordError) {
      return passwordError;
    }

    const phoneError = validatePhone(phone);
    if (phoneError) {
      return phoneError;
    }

    if (!industry.trim()) {
      return 'Industry is required.';
    }

    return '';
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    const normalizedEmail = normalizeEmail(email);
    setErrorMessage('');
    try {
      const res = await fetch('/api/send_otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: normalizedEmail })
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || 'OTP sending failed.');
      }
      setEmail(normalizedEmail);
      setOtpVisible(true);
    } catch (error) {
      console.error('OTP Send Error:', error);
      setErrorMessage(error.message);
    }
  };

  const handleOtpVerify = async (enteredOtp) => {
    const normalizedEmail = normalizeEmail(email);
    const res = await fetch('/api/verify_otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ otp: enteredOtp, email: normalizedEmail })
    });
    const data = await res.json();
    if (res.ok && data.verified) {
      setOtpVisible(false);
      setOtpVerified(true);
      await handleFinalSignup();
    } else {
      setErrorMessage(data.error || 'Invalid OTP');
    }
  };

  const handleFinalSignup = async () => {
    try {
      const validationError = validateForm();
      if (validationError) {
        setErrorMessage(validationError);
        return;
      }
      const payload = {
        company: company.trim(),
        email: normalizeEmail(email),
        password,
        phone: phone.trim(),
        industry: industry.trim(),
      };
      const response = await fetch('/api/signup-hire', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Signup failed.');
      }
      localStorage.setItem('user_email', data.email);
      navigate(`/companyhome`);
    } catch (error) {
      console.error('Error in signup request:', error);
      setErrorMessage(error.message || 'Signup failed.');
    }
  };

  return (
    <div className="min-h-screen w-full bg-background text-foreground flex flex-col justify-center items-center relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, hsl(var(--foreground)) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Logo Section - Top Left */}
      <div className="absolute top-6 left-6 md:top-8 md:left-8 z-10">
        <Link 
          to="/"
          className="transition-opacity hover:opacity-80"
        >
          <img
            src="/Logo.png"
            alt="Logo"
            className="h-8 md:h-10 w-auto object-contain drop-shadow-sm"
          />
        </Link>
      </div>
      
      <div className="flex justify-center items-center gap-12 max-w-7xl w-full flex-wrap px-6 py-12 md:flex-nowrap relative z-10">
        <Card className={cn(
          "flex flex-col w-full max-w-[480px] p-8 md:p-10",
          "bg-white border border-border/50",
          "shadow-xl shadow-primary/5",
          "transition-all duration-300",
          "hover:shadow-2xl hover:shadow-primary/10"
        )}>
          <CardContent className="w-full p-0 space-y-6">
            {/* Header */}
            <div className="space-y-3 mb-2">
              <Heading level="h1" className="text-4xl font-bold text-foreground tracking-tight">
                Join us today 👋
              </Heading>
              <Text size="base" variant="muted" className="text-muted-foreground leading-relaxed">
                Together, we create opportunities for growth, collaboration, and innovation – join us to be a part of something bigger.
              </Text>
            </div>

            {/* Form */}
            <form className="flex flex-col gap-5" onSubmit={handleSendOtp}>
              <div className="space-y-4">
                <div className="relative group/company">
                  <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/company:text-primary" />
                  <Input
                    type="text"
                    id="company"
                    placeholder="Company name"
                    aria-label="Company Name"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    required
                  />
                </div>

                <div className="relative group/email">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/email:text-primary" />
                  <Input
                    type="email"
                    id="email"
                    placeholder="Enter your email"
                    aria-label="Email Address"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="relative group/password">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/password:text-primary" />
                  <Input
                    type="password"
                    id="passwordd"
                    placeholder="Enter your password"
                    aria-label="Password"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="relative group/phone">
                  <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/phone:text-primary" />
                  <Input
                    type="tel"
                    id="phone"
                    placeholder="Phone number"
                    aria-label="Phone Number"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>

                <div className="relative group/industry">
                  <Briefcase className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/industry:text-primary" />
                  <Input
                    type="text"
                    id="industry"
                    placeholder="Industry"
                    aria-label="Industry"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={industry}
                    onChange={(e) => setIndustry(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <Checkbox id="remember" />
                <Label 
                  htmlFor="remember" 
                  className="text-sm font-normal cursor-pointer text-muted-foreground"
                >
                  Remember me
                </Label>
              </div>

              {errorMessage && (
                <div className="rounded-md bg-destructive/10 border border-destructive/20 p-3">
                  <Text size="sm" variant="destructive" className="text-destructive">
                    {errorMessage}
                  </Text>
                </div>
              )}

              <Button 
                type="submit" 
                variant="default"
                size="default"
                className="w-full h-11 font-semibold shadow-sm hover:shadow-md transition-all duration-200"
                style={{
                  backgroundColor: getColor('primary'),
                  color: getColor('primaryForeground'),
                  borderColor: getColor('primary')
                }}
              >
                Create Account
              </Button>
            </form>

            {/* Footer */}
            <div className="pt-4 text-center border-t border-border">
              <Text size="sm" variant="muted" className="text-muted-foreground">
                Already have an account?{' '}
                <Link 
                  to="/login" 
                  className={cn(
                    "text-primary hover:text-primary/90 font-bold",
                    "transition-colors underline-offset-4 hover:underline",
                    "text-base"
                  )}
                >
                  Log in
                </Link>
              </Text>
            </div>
          </CardContent>
        </Card>
        
        <div className="hidden lg:block flex-shrink-0">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-primary/10 via-primary/5 to-transparent rounded-2xl blur-2xl" />
            <img 
              className="relative w-full max-w-[520px] aspect-[0.72] object-cover rounded-2xl shadow-2xl"
              loading="lazy"
              src="./sam.jpg"
              alt="Sign up illustration"
            />
          </div>
        </div>
      </div>
      
      <OtpModal
        visible={otpVisible}
        onVerify={handleOtpVerify}
        onCancel={() => setOtpVisible(false)}
        onResend={handleSendOtp}
      />
    </div>
  );
}

export default SignupForm;
